<template>
  <div class="NavBarSearch">
    <span class="NavBarSearch__element">
      <span class="NavBarSearch__title">
        Search results for "{{ searchString }}"
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NavBarSearch',

  computed: {
    searchString () {
      return decodeURIComponent(this.$route.params.searchString)
    }
  }
}
</script>

<style lang="scss">
@import 'NavBarSearch';
</style>
